/**
 * A dead simple CSS and JS lazy loader
 * The file will only be loaded once (identified by its URL)
 */
class Loader {
    constructor() {
        this.requestedJSFiles_ = [];
        this.loadedJSFiles_ = [];
        this.callbackQueue_ = {};
        this.requestedCSSFiles_ = [];
    }
    loadJS(src, cb, errCb, crossorigin = false) {
        if (this.requestedJSFiles_.includes(src)) {
            // same url already requested, check if it is also loaded
            if (this.loadedJSFiles_.includes(src)) {
                if (typeof cb === 'function') {
                    cb();
                }
            }
            else {
                // file requested by another concurrent call, but not loaded yet, wait in queue
                if (Array.isArray(this.callbackQueue_[src])) {
                    this.callbackQueue_[src].push(cb);
                }
                else {
                    // create queue (for this src)
                    this.callbackQueue_[src] = [cb];
                }
            }
            return;
        }
        try {
            this.requestedJSFiles_.push(src);
            const ref = document.getElementsByTagName('script')[0];
            const script = document.createElement('script');
            if (typeof cb === 'function') {
                script.onload = () => {
                    this.loadedJSFiles_.push(src);
                    cb();
                    // process queue
                    if (this.callbackQueue_[src]) {
                        while (this.callbackQueue_[src].length > 0) {
                            const q = this.callbackQueue_[src].shift();
                            if (typeof q === 'function') {
                                q();
                            }
                        }
                    }
                };
            }
            if (typeof errCb === 'function') {
                script.onerror = () => {
                    errCb(new Error('Script loading failed!'));
                };
            }
            script.src = src;
            script.async = true;
            if (crossorigin) {
                script.setAttribute('crossorigin', '');
            }
            ref.parentNode?.insertBefore(script, ref);
        }
        catch (err) {
            // e.g. 404 or DOM error
            if (typeof errCb === 'function') {
                errCb(err);
            }
        }
    }
    loadCSS(href) {
        if (this.requestedCSSFiles_.includes(href)) {
            return null; // CSS file should only be loaded once!
        }
        try {
            const doc = document;
            const link = doc.createElement('link');
            const refs = (doc.body || doc.getElementsByTagName('head')[0]).childNodes;
            const ref = refs[refs.length - 1];
            link.rel = 'stylesheet';
            link.href = href;
            this.requestedCSSFiles_.push(href);
            ref.parentNode?.insertBefore(link, ref.nextSibling);
            return link;
        }
        catch (err) {
            console.error(err);
            return null;
        }
    }
}
const loader = new Loader();
export default loader;
